import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";

import { ApiService } from './api.service';
import { JwtService } from './jwt.service';
import { User } from '../models';
import { Observable ,  BehaviorSubject ,  ReplaySubject } from 'rxjs';
import {map, distinctUntilChanged, tap} from 'rxjs/operators';
import {HttpHeaders} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class UserorderService {

  private currentUserSubject = new BehaviorSubject<User>({} as User);
  public currentUser = this.currentUserSubject.asObservable().pipe(distinctUntilChanged());

  private isAuthenticatedSubject = new ReplaySubject<boolean>(1);
  public isAuthenticated = this.isAuthenticatedSubject.asObservable();

  constructor(
      private http: HttpClient,
      private apiService: ApiService,
      private jwtService: JwtService,
  ) {}

  purgeAuth() {
    // Remove JWT from localstorage
    this.jwtService.destroyToken();
    // Set current user to an empty object
    this.currentUserSubject.next({} as User);
    // Set auth status to false
    this.isAuthenticatedSubject.next(false);
  }

  getMerchant(): String {
    return window.localStorage['merchantuserid'];
  }

  getuserID(): String {
    return window.localStorage['merchantid'];
  } 
  
  userorder(credentials): Observable<User> {   
      return this.apiService.post('payment/merchants/' + this.getMerchant() +'/merchant-users/' + this.getuserID() +'/orders/search', credentials )
          .pipe(map( 
              data => {  
                  return data;
              }
          ));
  }

  refund(id): Observable<User> {   
 
    return this.apiService.put('payment/merchants/'+ this.getMerchant() +'/merchant-users/' + this.getuserID() + '/orders/'+ id+ '/refund' )
        .pipe(map(
            data => {  
                return data;
            }
        ));
}
 
cancel(id): Observable<User> {   
 
  return this.apiService.put('payment/merchants/'+ this.getMerchant() +'/merchant-users/' + this.getuserID() + '/orders/'+ id+ '/cancel' )
      .pipe(map(
          data => {  
              return data;
          }
      ));
}

ordercancel(id): Observable<User> {   
 
  return this.apiService.put('payment/merchants/'+ this.getMerchant() +'/merchant-users/' + this.getuserID() + '/orders/'+ id+ '/cancel' )
      .pipe(map(
          data => {  
              return data;
          }
      ));
}

merchants(): Observable<User> {   
 
  return this.apiService.get('merchants/'+ this.getMerchant() + '/users'  )
      .pipe(map(
          data => {  
              return data;
          }
      ));
}

    createMerchantUserOrderExport(requestBody): Observable<any> {
        return this.apiService.post('merchants/' + this.getMerchant() + '/order-exports', requestBody)
            .pipe(map(
                data => {
                    return data;
                }
            ));
    }

}